module.exports = __webpack_public_path__ + "static/media/14UNEP24.983280db.jpg";